import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "../../app/store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Re-export
export { useMediaQuery } from "./useMediaQuery";
export { useMutationWithFeedback } from "./useMutationWithFeedback";
export { useUnsavedChangesWarning } from "./useUnsavedChangesWarning";
